module.exports = __webpack_public_path__ + "img/ticket-outlined.361f03e6.svg";